@if ((menuSignal())?.length > 0) {
  <nav role="navigation" aria-label="subnavigation menu">
    <ul class="nav subnav-tabs">
      @for (menuItem of menuSignal(); track menuItem.id) {
        <li  class="nav-item mb-0 nav-link subnav-link">
          <!-- Does not use aria labels, screen readers use the aria-current attribute and the label text -->
          @if (!menuItem.disabled) {
            <a
              id={{menuItem.id}}
              [routerLink]="menuItem.route"
              routerLinkActive="active"
              #rla="routerLinkActive"
              [attr.aria-current]="rla.isActive"
              [routerLinkActiveOptions]="{exact: true}"
              [queryParams]="menuItem.params"
              queryParamsHandling="merge">
              {{menuItem.label}}
            </a>
          } @else {
            <p class="disabled-subnav-item" [ngbTooltip]="menuItem.tooltip">
              {{menuItem.label}}
            </p>
          }
        </li>
      }
    </ul>
  </nav>
}
